import { gql } from "@apollo/client";

export const SAVE_USER_COOKIE_CHOICE = gql`
  mutation saveUserCookieChoice($input: SaveUserCookieChoiceInput!) {
    saveUserCookieChoice(input: $input)
  }
`;
